"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authAudience = exports.authClientId = exports.authDomain = void 0;
exports.authDomain = process.env.VITE_AUTH0_DOMAIN;
exports.authClientId = process.env.VITE_AUTH0_CLIENT_ID;
exports.authAudience = process.env.VITE_AUTH0_AUDIENCE;
//# sourceMappingURL=config.js.map